import { applyMiddleware, createStore, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "@redux-devtools/extension";
import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";
import { setStore } from "./storeRef";

// Register on storeRef *after* createStore so other modules can read the store
// via getStore() without importing this file's `export const store` (TDZ / cycle).

const sagaMiddleware = createSagaMiddleware();

const appEnv = (import.meta.env?.VITE_ENV || "PREPROD").toUpperCase();
const composeEnhancers =
  appEnv !== "PROD" ? composeWithDevTools : compose;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

setStore(store); // must stay before sagaMiddleware.run so sagas see a registered store

store.sagaTask = sagaMiddleware.run(rootSaga);
